import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonMain } from '@quero-delivery/quero-components-web';
import Tooltip from 'rc-tooltip';
import {
  faEdit,
  faPowerOff,
  faCloudSlash,
  faSync,
  faLockOpen,
} from '@fortawesome/pro-solid-svg-icons';
import { useNavigate, useParams, Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { ROLE_TYPES } from '@/Interfaces/Data';
import { useAppSelector } from '@/_store/hooks';
import MotoboyReset from '@/features/motoboyReset/MotoboyReset';
import useMotoboy from '@/hooks/motoboy/useMotoboy';
import { ModalSetStatusOfflineDeliveryman } from '@/_features/deliveries/componentes/modal-change-status-deliveryman';
import { AccessPermission } from '@/_components/access-permission';
import PurpleButton from '@/Components/shared/purple-button/PurpleButton';
import styles from './styles.module.scss';
import { colors } from '@/Themes/Colors';
import { ModalBlock } from '../modal-block';
import { Breadcrumb } from '@/_components/breadcrumb';
import { selectUser } from '@/_store/modules/auth/selectors';
import { validationFlag } from '@/Utils/FnUtils';

// TODO Impelementar testes e refatorar requests
function HeaderButtons() {
  const navigate = useNavigate();
  const location = useLocation();
  const isFromMotoboyList = location.state?.from === 'motoboyList';

  const { motoboyId } = useParams<{ motoboyId: string }>();

  const { motoboy, updateMotoboy } = useMotoboy(motoboyId || '');

  const user = useAppSelector(selectUser);

  const [openModalSetMotoboyOffline, setOpenModalSetMotoboyOffline] =
    useState(false);
  const [openModalBlockMotoboy, setOpenModalBlockMotoboy] = useState(false);
  const [showMotoboyResetModal, setShowMotoboyResetModal] = useState(false);

  function openModalBlock() {
    setOpenModalBlockMotoboy(true);
  }

  function closeModalBlock() {
    setOpenModalBlockMotoboy(false);
  }

  function goToEditMotoboy() {
    if (motoboy) {
      navigate(`/entregadores/${motoboy._id}/editar`);
    } else {
      toast.warn('Motoboy inválido');
    }
  }

  const hasPermissionResetDeliveryman = validationFlag({
    flags: user?.flags,
    flagNameValidation: 'hasPermissionResetDeliveryman',
  });

  if (!motoboy) {
    return null;
  }

  return (
    <div>
      <div className="header-container">
        <Breadcrumb className="mg-bottom-sm" aria-busy="false">
          {isFromMotoboyList ? (
            <button onClick={() => navigate(-1)}>Lista</button>
          ) : (
            <Link className="text-gray" relative="path" to="/entregadores">
              Lista
            </Link>
          )}

          <Link data-actived className="text-gray" relative="path" to="">
            {motoboy.nomeFantasia || motoboy.nome}
          </Link>
        </Breadcrumb>

        <div className={styles.motoboyActions}>
          <AccessPermission permissionKey="deliveryman.dedicateDeliveryman">
            <PurpleButton
              onClick={() => {
                navigate('dedicar');
              }}
              style={{ whiteSpace: 'nowrap' }}
            >
              <b>dedicar entregador</b>
            </PurpleButton>
          </AccessPermission>

          <AccessPermission permissionKey="deliveryman.blockDeliveryman">
            <Tooltip overlay="Deixar entregador offline" placement="top">
              <ButtonMain
                customIcon={
                  <FontAwesomeIcon icon={faCloudSlash} color={colors.brand10} />
                }
                disabled={motoboy.status !== 'DISPONIVEL'}
                className={styles.actionIcon}
                onClick={() => setOpenModalSetMotoboyOffline(true)}
              />
            </Tooltip>
          </AccessPermission>

          <Tooltip overlay="Atualizar entregador" placement="top">
            <ButtonMain
              customIcon={
                <FontAwesomeIcon icon={faSync} color={colors.brand10} />
              }
              className={styles.actionIcon}
              onClick={() => updateMotoboy(motoboy._id)}
            />
          </Tooltip>

          {user?.managerLogType !== ROLE_TYPES.LOGISTIC_OPERATOR &&
            hasPermissionResetDeliveryman && (
              <Tooltip overlay="Resetar entregador" placement="top">
                <ButtonMain
                  customIcon={
                    <FontAwesomeIcon icon={faPowerOff} color={colors.brand10} />
                  }
                  className={styles.actionIcon}
                  onClick={() => setShowMotoboyResetModal(true)}
                />
              </Tooltip>
            )}

          <AccessPermission permissionKey="deliveryman.blockDeliveryman">
            <Tooltip overlay="Bloqueios" placement="top">
              <ButtonMain
                customIcon={
                  <FontAwesomeIcon icon={faLockOpen} color={colors.brand10} />
                }
                className={styles.actionIcon}
                onClick={openModalBlock}
              />
            </Tooltip>
          </AccessPermission>

          <AccessPermission permissionKey="deliveryman.editDeliveryman">
            <Tooltip overlay="Editar entregador" placement="top">
              <ButtonMain
                customIcon={
                  <FontAwesomeIcon icon={faEdit} color={colors.brand10} />
                }
                className={styles.actionIcon}
                onClick={goToEditMotoboy}
              />
            </Tooltip>
          </AccessPermission>
        </div>
      </div>

      {openModalSetMotoboyOffline ? (
        <ModalSetStatusOfflineDeliveryman
          open={openModalSetMotoboyOffline}
          onClose={() => setOpenModalSetMotoboyOffline(false)}
          fnCallback={() => {
            if (motoboy._id) {
              updateMotoboy(motoboy._id);
            }
          }}
          deliverymenIds={[motoboy._id]}
        />
      ) : null}

      <ModalBlock open={openModalBlockMotoboy} onClose={closeModalBlock} />

      {showMotoboyResetModal ? (
        <MotoboyReset
          motoboyId={motoboy._id}
          onClose={(needUpdate: boolean) => {
            setShowMotoboyResetModal(false);

            if (needUpdate && motoboy) {
              updateMotoboy(motoboy._id);
            }
          }}
        />
      ) : null}
    </div>
  );
}

export { HeaderButtons };
